import {
  PROJECT_STORE, ProjectStore,
  GENERAL_STORE, GeneralStore
} from 'store'
import { ProjectTypes, ApiVovSubtypes, GenreTypes } from 'models'

export interface Props {
  [PROJECT_STORE]?: ProjectStore;
  [GENERAL_STORE]?: GeneralStore;
  project?: any;
  parentId?: string;
}

export interface State {
  isScrollOnTop: boolean;
  name: string;
  type: ProjectTypes;
  subtype: ApiVovSubtypes;
  genres: GenreTypes[];
  year: number;
  tags: string[];
  info: string;
  images: any[];
  actors: any[];
  directors: any[];
  producers: any[];
  relatedMedia: any[];
  brands: any[];
  videoUrl: string;
}

export const genreOptions = Object.values(GenreTypes)
